import { buildCsvTemplate } from '../../data/masterData';

export function downloadCsvTemplate(moduleKey) {
  const csv = buildCsvTemplate(moduleKey);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${moduleKey}_master_template.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
